import React, { useMemo } from 'react'

import { unformatMoney, calculatePercentage } from '~/helpers'

import * as S from './styles'

const WARNING_THRESHOLD_PCT = 30
const DANGER_THRESHOLD_PCT = 90

interface ProgressBarProps extends React.HTMLAttributes<HTMLDivElement> {
  value: number
  goal: number
  showPercentage?: boolean
  showTotal?: boolean
  isDesc?: boolean
  template?: string | null
}

const ProgressBar = ({
  value,
  goal,
  showPercentage = false,
  showTotal = false,
  template = null,
  isDesc = false,
  ...rest
}: ProgressBarProps) => {
  const percentage = calculatePercentage(value, goal)

  const templateProgressBar = useMemo(() => {
    const toGoal = Number(unformatMoney(goal))
    const current = Number(unformatMoney(value))
    const percentageOfGoal = calculatePercentage(current, toGoal)

    if (percentageOfGoal <= WARNING_THRESHOLD_PCT) {
      return 'success'
    }
    if (
      percentageOfGoal > WARNING_THRESHOLD_PCT &&
      percentageOfGoal < DANGER_THRESHOLD_PCT
    ) {
      return 'warning'
    }
    if (percentageOfGoal >= DANGER_THRESHOLD_PCT) {
      return 'danger'
    }

    return 'default'
  }, [goal, value])

  return (
    <S.Container {...rest}>
      <S.Bar>
        <S.Progress
          percentage={Number(percentage.toFixed(2))}
          template={template || templateProgressBar}
          isDesc={isDesc}
        />
      </S.Bar>

      {showPercentage && <S.Label>{percentage.toFixed(2)}%</S.Label>}

      {showTotal && (
        <S.Label>
          {value}/{goal}
        </S.Label>
      )}
    </S.Container>
  )
}

export default ProgressBar
